import React, {
  createContext,
  useState,
  useContext,
  useRef,
  useEffect,
} from "react";

const DialogContext = createContext();

export const useCustomDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);

  const alert = (message) =>
    new Promise((resolve) => {
      setDialog({
        type: "alert",
        message,
        onConfirm: () => {
          setDialog(null);
          resolve();
        },
      });
    });

  const confirm = (message) =>
    new Promise((resolve) => {
      setDialog({
        type: "confirm",
        message,
        onConfirm: () => {
          setDialog(null);
          resolve(true);
        },
        onCancel: () => {
          setDialog(null);
          resolve(false);
        },
      });
    });

  return (
    <DialogContext.Provider value={{ alert, confirm }}>
      {children}
      {dialog && <DialogModal dialog={dialog} />}
    </DialogContext.Provider>
  );
};

const DialogModal = ({ dialog }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    modalRef.current?.focus();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      dialog.onConfirm?.();
    } else if (e.key === "Escape" && dialog.type === "confirm") {
      dialog.onCancel?.();
    }
  };

  return (
    <div
      ref={modalRef}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className="bg-white p-6 rounded-lg shadow-xl text-center max-w-sm w-full outline-none">
        <p className="mb-4 text-lg">{dialog.message}</p>
        <div className="flex justify-center gap-4">
          {dialog.type === "confirm" && (
            <>
              <button
                onClick={dialog.onConfirm}
                className="bg-slate-800 text-white px-6 py-2 rounded-full hover:bg-slate-600"
              >
                Yes
              </button>
              <button
                onClick={dialog.onCancel}
                className="border-2 text-black px-6 py-2 rounded-full hover:bg-slate-100"
              >
                No
              </button>
            </>
          )}
          {dialog.type === "alert" && (
            <button
              onClick={dialog.onConfirm}
              className="bg-slate-800 text-white px-6 py-2  hover:bg-slate-600 rounded-full"
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
